import { getNamespacedResource } from "../util";
const USER_NAMESPACE = "user";
const DATA_PREFILL_FROM_ID = "dataPrefillFromId";
const USER_TYPES = {
    getters: {
        [DATA_PREFILL_FROM_ID]: getNamespacedResource(USER_NAMESPACE, DATA_PREFILL_FROM_ID)
    }
};

export { USER_NAMESPACE, USER_TYPES };

export function createUserModule(state) {
    return {
        namespaced: true,
        state: state,
        getters: {
            [DATA_PREFILL_FROM_ID](state) {
                return function (dataFieldId) {
                    return state.DataPrefills[dataFieldId];
                };
            }
        }
    };
}
